import './styles.css';
import React from 'react';

const Policy = () => {
    const policyContent = [
        {
            title: '제1조(목적)',
            content: '아주대학교 총학생회(이하 "총학생회") 홈페이지(이하 "홈페이지") 서비스이용약관은 총학생회가 제공하는 홈페이지 서비스의 이용과 관련하여 관리자와 사용자 간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.'
        },
        {
            title: '제2조(정의)',
            type: 'list',
            items: [
                {
                    content: '이 약관에서 사용하는 용어의 정의는 아래와 같습니다.',
                    subItems: [
                        '"서비스"란, 홈페이지가 제공하는 모든 서비스 및 기능을 말합니다.',
                        '"관리자"란, 홈페이지의 개발, 유지보수, 수정, 업데이트, 관리 등을 담당하는 총학생회 임원 혹은 기타 관련자를 말합니다.',
                        '"사용자"란, 이 약관에 따라 홈페이지에 접속하고 서비스를 이용하는 회원 및 비회원을 말합니다.',
                        '"회원"이란, 홈페이지에 회원등록을 하고 서비스를 이용하는 자를 말합니다.',
                        '"비회원"이란, 홈페이지에 회원등록을 하지 않고 서비스를 이용하는 자를 말합니다.',
                        '"회원등록"이란, 홈페이지에 회원가입을 하고 개인정보 수집 및 이용에 동의함으로써 회원으로 인증되어 홈페이지가 제공하는 서비스를 제한 없이 이용할 수 있게 되는 과정을 말합니다.',
                        '"게시물"이란, 관리자 혹은 사용자가 홈페이지에 게재한 모든 종류의 글, 사진, 영상, 첨부파일, 광고, 건의사항 등을 말합니다.',
                        '"연락처"란, 회원가입이나 본인 인증 등 사용자의 동의하에 수집된 사용자의 휴대전화 번호, 이메일 등을 말합니다.',
                        '"소속"이란, 회원 혹은 회원등록을 하려는 개인을 아주대학교 내에서 식별할 수 있는 학과, 학년, 기타 학적 등의 정보를 말합니다.',
                        '"본인 인증"이란, 아이핀, 휴대전화 번호, 이메일 등을 이용한 본인 확인 절차를 말합니다.',
                        '"학교 인증"이란, 아주대학교 이메일 등을 이용해 회원 혹은 회원등록을 하려는 자가 아주대학교 소속이거나 관련자임을 확인하는 절차를 말합니다.'
                    ]
                },
                '제1항에서 정의되지 않은 본 약관 내 용어의 의미는 상식적이고 일반적인 관행에 따릅니다.',
                '제1항에서 정의된 용어의 의미는 "개인정보 수집 및 이용" 안내에 동일하게 적용됩니다.'
            ]
        },
        {
            title: '제3조(약관의 효력 및 변경)',
            type: 'list',
            items: [
                '이 약관은 홈페이지에 게시함으로써 효력이 발생합니다.',
                '관리자는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 변경할 수 있습니다.',                
                '사용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 회원탈퇴를 요청할 수 있습니다.'
            ]
        },
        {
            title: '제4조(서비스의 제공)',
            type: 'list',
            items: [
                '홈페이지는 다음과 같은 서비스를 제공합니다:',
                {
                    content: '회원가입 및 로그인 서비스',
                    subItems: [
                        '아주대학교 소속 확인을 위한 학교 인증',
                        '개인정보 관리 및 수정',
                        '게시물 작성 및 조회',
                        'Q&A 및 건의사항 접수',
                        '공지사항 및 소식 전달',
                        '자료실 및 파일 다운로드',
                        '기타 총학생회 관련 서비스'
                    ]
                },
                '서비스의 이용은 연중무휴, 1일 24시간을 원칙으로 합니다.',            
            ]
        },
        {
            title: '제5조(회원가입)',
            type: 'list',
            items: [
                '홈페이지 서비스를 이용하려는 자는 이 약관에 동의하고 회원가입을 완료해야 합니다.',
                '회원가입 시 다음 사항을 준수해야 합니다:',
                {
                    content: '회원가입 요구사항',
                    subItems: [                        
                        '아주대학교 소속임을 확인하는 학교 인증 절차 완료',
                        '개인정보 수집 및 이용에 대한 동의',
                        '이용약관 및 개인정보처리방침에 대한 동의'
                    ]
                },
                '관리자는 회원가입 신청자의 자격을 확인하고, 적절하지 않은 경우 가입을 거부할 수 있습니다.',
            ]
        },
        {
            title: '제6조(회원의 의무)',
            type: 'list',
            items: [
                '회원은 다음 사항을 준수해야 합니다:',
                {
                    content: '회원 의무사항',
                    subItems: [
                        '관련 법령 및 이 약관의 준수',
                        '다른 회원의 권리나 명예, 신용 등을 침해하는 행위 금지',
                        '홈페이지의 정상적인 운영을 방해하는 행위 금지',
                        '허위 정보의 게시 및 유포 금지',
                        '상업적 목적의 광고성 게시물 게시 금지',
                        '음란, 폭력, 기타 공서양속에 반하는 정보의 게시 금지',
                        '타인의 개인정보를 수집, 저장, 공개하는 행위 금지',
                        '컴퓨터 바이러스 등 유해한 프로그램의 유포 금지'
                    ]
                },
                '회원이 위 사항을 위반한 경우, 관리자는 경고, 일시정지, 영구정지 등의 조치를 취할 수 있습니다.',
            ]
        },
        {
            title: '제7조(게시물의 관리)',
            type: 'list',
            items: [
                '회원은 자신이 게시한 게시물에 대해 책임을 져야 합니다.',
                '관리자는 다음에 해당하는 게시물을 사전 통지 없이 삭제할 수 있습니다:',
                {
                    content: '삭제 대상 게시물',
                    subItems: [
                        '관련 법령에 위배되는 내용',
                        '다른 회원의 권리를 침해하는 내용',
                        '홈페이지의 운영을 방해하는 내용',
                        '공서양속에 반하는 내용',
                        '기타 관리자가 부적절하다고 판단하는 내용'
                    ]
                },
                '관리자는 게시물의 삭제 사유를 해당 회원에게 통지하지 않고 삭제할 수 있습니다.'
            ]
        },
        {
            title: '제8조(개인정보보호)',
            content: '개인정보의 수집, 이용, 보관, 파기 등에 관한 사항은 개인정보처리방침에 따릅니다.'
        },
        {
            title: '제9조(면책조항)',
            type: 'list',
            items: [
                '관리자는 천재지변, 전쟁, 기타 불가항력적인 사유로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.',
                '관리자는 회원의 귀책사유로 인한 서비스 이용의 장애에 대해 책임을 지지 않습니다.',
                '관리자는 회원이 게시한 게시물의 내용에 대해 책임을 지지 않습니다.',
                '관리자는 회원 간 또는 회원과 제3자 간의 분쟁에 대해 개입하지 않으며, 이로 인한 손해에 대해 책임을 지지 않습니다.'
            ]
        },
        {
            title: '제10조(분쟁해결)',
            type: 'list',
            items: [
                '이 약관과 관련하여 분쟁이 발생한 경우, 관리자와 회원은 상호 협의하여 해결합니다.',
                '협의가 이루어지지 않는 경우, 관련 법령에 따라 해결합니다.',
                '이 약관의 해석에 관하여는 한국어를 우선으로 합니다.'
            ]
        },
    ];

    const renderPolicySection = (section) => (
        <div key={section.title}>
            <h2>{section.title}</h2>
            {section.type === 'list' ? (
                <ol>
                    {section.items.map((item, index) => (
                        <li key={index}>
                            {typeof item === 'string' ? item : item.content}
                            {item.subItems && (
                                <ol type="1">
                                    {item.subItems.map((subItem, subIndex) => (
                                        <li key={subIndex}>{subItem}</li>
                                    ))}
                                </ol>
                            )}
                        </li>
                    ))}
                </ol>
            ) : (
                <p>{section.content}</p>
            )}
        </div>
    );

    const renderPolicyContent = () => (
        <div className="terms-content">
            {policyContent.map(renderPolicySection)}
        </div>
    );

    return (
        <div className="context">
            <div className="contextTitle">이용약관</div>
            <hr className="titleSeparator"/>
            {renderPolicyContent()}
        </div>
    );
};

export default Policy;